import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceCustomFieldsComponent } from './marketplace-custom-fields.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [MarketplaceCustomFieldsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FGBSharedModule
  ],
  exports: [MarketplaceCustomFieldsComponent],
})
export class MarketplaceCustomFieldsModule {}
